import { render, staticRenderFns } from "./ManageProfileListItem.vue?vue&type=template&id=5d8f8b9a&scoped=true"
import script from "./ManageProfileListItem.vue?vue&type=script&lang=ts"
export * from "./ManageProfileListItem.vue?vue&type=script&lang=ts"
import style0 from "./ManageProfileListItem.vue?vue&type=style&index=0&id=5d8f8b9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8f8b9a",
  null
  
)

export default component.exports